import { useState } from 'react'
import { ScrollView, View } from 'react-native'
import { Image } from 'expo-image'
import Typography from '@ui/typography'
import Checklist from '@ui/elements/Checklist'
import Page from '@shell/Page'

export default function DevChecklistPage() {
  const [step, setStep] = useState(0)
  return (
    <Page stage="dev">
      <View className="gap-8 p-16">
        <Checklist
          step={step}
          setStep={setStep}
          steps={[
            {
              title: 'Prescription',
              desc: 'Select the prescription based on which we will start the order. Sign up for an eye test if you do not have any prescriptions yet.',
              button: {
                label: step !== 0 ? 'Change' : 'Select',
                onPress: () => setStep(step === 0 ? 1 : 0),
              },
            },
            {
              title: 'Frame Selection',
              desc: 'From the many frames available in our store, choose the one you would like to configure for this order next.',
              button: {
                label: step !== 1 ? 'Change' : 'Select',
                onPress: () => setStep(step === 1 ? 2 : 1),
              },
            },
            {
              title: 'Configuration',
              desc: 'Glasses Advisor will help you configure the glasses. On every step you will be able to choose one of many options. Watch provided videos to learn more about each setting.',
              button: {
                label: step !== 2 ? 'Change' : 'Start',
                onPress: () => setStep(step === 2 ? 3 : 2),
              },
              node: (
                <View className="gap-4">
                  <Typography variant="SMB">Gino Vera • CL027-402</Typography>
                  <Image
                    transition={200}
                    contentFit="contain"
                    contentPosition="left bottom"
                    style={{ width: 'auto', height: 128 }}
                    source={require('@/images/frames/angle/CL027-402-2.png')}
                  />
                </View>
              ),
            },
            {
              title: 'Summary',
              button: {
                label: 'View',
                onPress: () => setStep(step === 3 ? 4 : 3),
              },
            },
            {
              title: 'Checkout',
              button: {
                label: 'View',
                onPress: () => setStep(step === 4 ? 5 : 4),
              },
            },
            {
              title: 'Payment',
              button: {
                label: step !== 5 ? 'Check' : 'Pay',
                onPress: () => setStep(step === 5 ? 6 : 5),
              },
            },
          ]}
        />
      </View>
    </Page>
  )
}
